import { useContext, useEffect, useState } from "react";
import placeholder from "../inc/placeholder.jpg";
import { SiteContext } from "../contexts/SiteContext";
import { makeStyles } from "@material-ui/core";
import {
	Paper,
	Typography,
	Fade,
	Card,
	CardMedia,
	CardContent,
} from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: "1rem",
	},
	card: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
		textDecoration: "none",
		transition: ".3s",
		"&:hover": {
			backgroundColor: "#f9f9f9",
			transform: "translateY(-3px)",
		},
		marginTop: "1rem",
	},
	cardImage: {
		//paddingTop: "56.25%", // 16:9 aspect ratio (9/16=0.5625)
		paddingTop: "100%", // 1:1 aspect ratio (sq)
		borderRadius: "5px",
	},
}));

function Spotlight() {
	const classes = useStyles();
	const { selectedSite } = useContext(SiteContext);
	const [allDocuments, setAllDocuments] = useState([]);
	const [randomDocument, setRandomDocument] = useState();
	const [loading, setLoading] = useState(true);

	useState(() => {
		async function getAllInSite(resourceName) {
			try {
				const res = await fetch(
					`${process.env.REACT_APP_API_URL}/${resourceName}`,
					{
						credentials: "include",
					}
				);
				const resource = await res.json();
				if (resource.success) {
					// Get only the resources within the current site
					const resourcesInSite = resource.data.filter(
						(item) => item.unit.site._id === selectedSite._id
					);
					// Add the documents to the allDocuments state
					setAllDocuments((prevState) => prevState.concat(resourcesInSite));
				} else {
					console.log(resource.error);
				}
			} catch (e) {
				console.log(e);
			}
		}
		getAllInSite("entries");
		getAllInSite("people");

		// Get a random item from the array of all entries and people within the site
	}, [selectedSite]);

	useEffect(() => {
		const randomFromAll =
			allDocuments[Math.floor(Math.random() * allDocuments.length)];
		setRandomDocument(randomFromAll);
	}, [allDocuments]);

	useEffect(() => {
		if (randomDocument) {
			setLoading(false);
		}
	}, [randomDocument]);

	if (loading) {
		return "Loading...";
	}

	return (
		<Fade in={typeof selectedSite != undefined}>
			<Paper className={classes.paper}>
				<Typography variant="h6">Spotlight</Typography>
				<Card
					component={Link}
					to={
						// The 'entries' have the 'title' field, but the people have the 'name' field
						randomDocument.title
							? `${selectedSite.slug}/entries/${randomDocument.slug}`
							: `${selectedSite.slug}/people/${randomDocument.slug}`
					}
					elevation={0}
					className={classes.card}
				>
					<CardMedia
						className={classes.cardImage}
						image={
							randomDocument.featuredImage
								? `${process.env.REACT_APP_FILE_URL}/${randomDocument.featuredImage.thumbnailName}`
								: //: "https://source.unsplash.com/random?collection=1995427&size=500x500"
								  placeholder
						}
						title={
							// The 'entries' have the 'title' field, but the people have the 'name' field
							randomDocument.title ? randomDocument.title : randomDocument.name
						}
					/>
					<CardContent className={classes.cardContent}>
						<Typography align="center">
							{
								// The 'entries' have the 'title' field, but the people have the 'name' field
								randomDocument.title
									? randomDocument.title
									: randomDocument.name
							}
						</Typography>
					</CardContent>
				</Card>
			</Paper>
		</Fade>
	);
}

export default Spotlight;
